import IndividualTable from "../../../IndividualTable";
import { sampleData } from "../../sampleData";

const Distance90 = () => {
  let winners = ["220", "363", "428", "366", "17", "512", "217", "431"];
  return <IndividualTable matchType={"16"} gender="M" event="90" subTitle="TarscaShild" data={sampleData} topRankCount="8" winners={winners} />;
};
export default Distance90;
